export default "__VITE_ASSET__Bem4W75c__"